import { render, staticRenderFns } from "./editpohon.vue?vue&type=template&id=7668ba46&"
import script from "./editpohon.vue?vue&type=script&lang=js&"
export * from "./editpohon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports